// Umbrella identity stays independent of each sport module.
export const BRAND = Object.freeze({
  name: 'Sports Hub Connect',
  wordmark: '/brand/sports-hub-connect-wordmark.webp',
  helix: '/brand/sports-hub-connect-helix.webp',
});

// Baseball is the only released module. No inactive sport options are exposed.
export const CURRENT_SPORT = Object.freeze({ id: 'baseball', name: 'Baseball' });